import { Typography } from '@mui/material';
import { isToday } from '@modules/common/helpers/date';

import { DividedRow } from './DividedRow';
import { SimulationGroup } from '@thive/fddm-types';

type Props = {
  simulation: SimulationGroup;
};

export const CreatedCompletedDatesRow = ({ simulation }: Props) => {
  const created = new Date(simulation.created);

  const time = new Date(created).toLocaleTimeString([...navigator.languages], {
    hour: '2-digit',
    minute: '2-digit',
  });

  if (isToday(created)) {
    return <Typography sx={{ fontSize: '10px' }}>{time}</Typography>;
  }

  return <DividedRow left={created.toLocaleDateString()} right={time} />;
};
